class CategorySwitch {
    constructor (el) {
        this.$eDevice = el.$module;
        this.$mains = el.$mains;
        this.$headline = el.$module.querySelector('[data-e-device="headline"]');
        this.$subline = el.$module.querySelector('[data-e-device="subline"]');
        this.$prev = el.$module.querySelector('[data-e-device="category-prev"]');
        this.$next = el.$module.querySelector('[data-e-device="category-next"]');
        this.mainSlider = el.mainSlider;
        this.imageSlider = el.imageSlider;
    }

    init () {
        this.bindEvents();
        this.checkArrows();
    }

    bindEvents () {
        this.$next.addEventListener('click', () => {
            this.goToNext();
            this.checkArrows();
            this.fireChangeEvent();
        });

        this.$prev.addEventListener('click', () => {
            this.goToPrev();
            this.checkArrows();
            this.fireChangeEvent();
        });
    }

    goToNext () {
        const activeIndex = this.getActiveSlider();
        // eslint-disable-next-line no-use-before-define, no-undef
        if (activeIndex < eDeviceCategories.length - 1) {
            this.hideActiveSlider();
            this.$mains[activeIndex + 1].classList.add('e-device__main--active');

            this.changeNavigationContent();
            this.changeHeadlines();
        }
    }

    goToPrev () {
        const activeIndex = this.getActiveSlider();
        if (activeIndex > 0) {
            this.hideActiveSlider();
            this.$mains[activeIndex - 1].classList.add('e-device__main--active');

            this.changeNavigationContent();
            this.changeHeadlines();
        }
    }

    hideActiveSlider () {
        for (let i = 0; i < this.$mains.length; i++) {
            const $main = this.$mains[i];
            if ($main.classList.contains('e-device__main--active')) {
                $main.classList.remove('e-device__main--active');
            }
        }
    }

    // checks if an arrow is needed, otherwise hide it
    // for example first slider is active, then is needs no prev arrow
    checkArrows () {
        const activeSlider = this.getActiveSlider();

        if (activeSlider === 0) {
            this.$prev.classList.add('e-device--transparent');
        } else {
            this.$prev.classList.remove('e-device--transparent');
        }
        // eslint-disable-next-line no-use-before-define, no-undef
        if (activeSlider === eDeviceCategories.length - 1) {
            this.$next.classList.add('e-device--transparent');
        } else {
            this.$next.classList.remove('e-device--transparent');
        }
    }

    getActiveSlider () {
        for (let i = 0; i < this.$mains.length; i++) {
            const $main = this.$mains[i];
            if ($main.classList.contains('e-device__main--active')) {
                return i;
            }
        }

        return -1;
    }

    changeNavigationContent () {
        const activeIndex = this.getActiveSlider();
        // eslint-disable-next-line no-use-before-define, no-undef
        const content = eDeviceCategories[activeIndex];

        if (content.prev.length > 0) {
            this.$prev.querySelector('span').firstChild.data = content.prev;
        }

        if (content.next.length > 0) {
            this.$next.querySelector('span').firstChild.data = content.next;
        }
    }

    changeHeadlines () {
        const activeIndex = this.getActiveSlider();
        // eslint-disable-next-line no-use-before-define, no-undef
        const content = eDeviceCategories[activeIndex];

        this.$headline.firstChild.data = content.headline;
        this.$subline.firstChild.data = content.subline;
    }

    fireChangeEvent () {
        let event = null;
        if (typeof (Event) === 'function') {
            event = new Event('categoryChange');
        }

        this.$eDevice.dispatchEvent(event);
    }
}

export { CategorySwitch };
